import React from 'react';

/**
 * AutoDistrict brand logo.
 *
 * Uses the official artwork files stored in /public/logo/.
 *
 * Variants:
 *   - default : primary logo (navy on light background)
 *   - light   : reversed logo (white/emerald on dark background — hero, dark sections)
 *
 * Sizes control the rendered height; width scales automatically.
 */
const HEIGHTS = {
  sm: 'h-6 sm:h-7',
  md: 'h-8 sm:h-9',
  lg: 'h-10 sm:h-12',
};

const Logo = ({ variant = 'default', className = '', size = 'md' }) => {
  const isLight = variant === 'light';
  const src = isLight
    ? '/logo/autodistrict-logo-reversed.webp'
    : '/logo/autodistrict-logo-primary.webp';

  return (
    <span
      className={`inline-flex items-center ${className}`}
      data-testid="brand-logo"
    >
      <img
        src={src}
        alt="AutoDistrict"
        className={`${HEIGHTS[size] || HEIGHTS.md} w-auto object-contain select-none`}
        draggable="false"
        loading="eager"
        decoding="async"
      />
    </span>
  );
};

export default Logo;
